import React from "react";

export default function AdvancedReportChart(props) {
  return (
    <div
      {...props}
      className="w-[300px] p-4 bg-white rounded-2xl flex-col justify-start items-center gap-[30px] inline-flex"
    >
      <div className="self-stretch justify-between items-start inline-flex">
        <div className="grow shrink basis-0 flex-col justify-start items-start gap-[13px] inline-flex">
          <p className="opacity-70 text-[#222222]/60 text-base font-normal  leading-normal">
            {props.title}
          </p>
          <p className="text-[#222222] text-3xl font-semibold  leading-9">
            {props.totaluser}
          </p>
        </div>
        <div
          style={{ backgroundColor: props.userbg }}
          className="w-[60px] h-[60px] flex justify-center items-center rounded-3xl"
        >
          <img src={props.usericon} />
        </div>
      </div>
      <div className="relative w-[280px] flex-col justify-start items-center gap-4 flex">
        <div className="flex items-center justify-center">{props.children}</div>
        <div className="top-[33%] absolute flex flex-col items-center">
          <h3 className="text-basePrimary text-[22.24px] font-semibold  leading-[33.37px]">
            {props.totaluser}
          </h3>
          <p className="text-[#222222]/60 text-[9.89px] font-normal  leading-[14.83px]">
            Users
          </p>
        </div>
        <div className="self-stretch justify-between items-start inline-flex">
          <div className="flex-col justify-start items-start gap-3 inline-flex">
            <a href="#">
              <div className="justify-start items-center gap-2 flex">
                <div
                  style={{ backgroundColor: props.malecolor }}
                  className="w-3 h-3 rounded-full"
                />
                <p className="text-[#222222] text-sm font-normal  leading-tight">
                  {props.maletitle}
                </p>
              </div>
            </a>
            <a href="#">
              <div className="justify-start items-center gap-2 flex">
                <div
                  style={{ backgroundColor: props.femalecolor }}
                  className="w-3 h-3 rounded-full"
                />
                <p className="text-[#222222] text-sm font-normal  leading-tight">
                  {props.femaletitle}
                </p>
              </div>
            </a>
          </div>
          <div className="flex-col justify-start items-start gap-3 inline-flex">
            <p className="text-[#222222]/60 text-sm font-normal  leading-tight">
              {props.malepercentage} %
            </p>
            <p className="text-[#222222]/60 text-sm font-normal  leading-tight">
              {props.femalemalepercentage} %
            </p>
          </div>
        </div>
      </div>
      {/* <div className="self-stretch justify-center items-center gap-2 flex">
        <div className="w-5 h-5 relative">
          <img src={props.historyicon} />
        </div>
        <div>
          <span
            style={{ color: props.historypercentagecolor }}
            className="text-base font-normal  leading-normal"
          >
            {props.historypercentage}
          </span>
          <span className="text-[#222222]/60 text-base font-normal  leading-normal">
            {" "}
            {props.historytitle}
          </span>
        </div>
      </div> */}
    </div>
  );
}
